import { AlertTitle, Collapse, Typography } from "@mui/material"
import { ReactElement } from "react"
import { FieldError, FieldErrorsImpl, Merge } from "react-hook-form"

import { IFormProperties } from "../../../../services/middleware/types/singleApplication/getSchemaTypes"
import { getValue } from "../../../../utils/general/generalUtils"
import AppAlert from "../../../dataDisplay/alerts/appAlert"

interface IArrayFormAlertProps {
    errors: Merge<
        FieldError,
        FieldErrorsImpl<{
            [x: string]: object
        }>
    >
    formProperties: IFormProperties
}

/** Displays error state for a given index in an array form (either single
 * or multiple array form.) */
const ArrayFormErrorDisplay = ({
    errors,
    formProperties,
}: IArrayFormAlertProps): ReactElement => (
    <Collapse in={Object.keys(errors).length > 0}>
        <AppAlert severity="warning">
            <AlertTitle>
                {Object.keys(errors).length > 1
                    ? `There are ${
                          Object.keys(errors).length
                      } things not quite right with your information`
                    : "There is one thing not quite right with your information"}
            </AlertTitle>
            <>
                {Object.entries(errors).map(([key, value]) => (
                    <Typography variant="body1" key={key}>
                        {getValue(formProperties, key)?.title} —{" "}
                        <strong>{value?.message as string}</strong>
                    </Typography>
                ))}
            </>
        </AppAlert>
    </Collapse>
)

export default ArrayFormErrorDisplay
